import { render, staticRenderFns } from "./CooperateBrand.vue?vue&type=template&id=419bb374&scoped=true"
import script from "./CooperateBrand.vue?vue&type=script&lang=js"
export * from "./CooperateBrand.vue?vue&type=script&lang=js"
import style0 from "./CooperateBrand.vue?vue&type=style&index=0&id=419bb374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419bb374",
  null
  
)

export default component.exports